import { render, staticRenderFns } from "./ycjpxblist.vue?vue&type=template&id=f8617356&scoped=true"
import script from "./ycjpxblist.vue?vue&type=script&lang=js"
export * from "./ycjpxblist.vue?vue&type=script&lang=js"
import style0 from "./ycjpxblist.vue?vue&type=style&index=0&id=f8617356&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8617356",
  null
  
)

export default component.exports